import { ApolloProvider } from "@apollo/client"
import { useEffect, useMemo } from "react"
import getClient from "./client"

export const useBlocksClient = ({ client, endpoint, authToken, headers }) => {
  const resolved = useMemo(
    () => client || getClient({ endpoint, authToken, headers }),
    [client, endpoint, authToken, headers]
  )
  useEffect(
    () => () => {
      if (!client) resolved.stop()
    },
    [client, resolved]
  )
  return resolved
}

const BlocksApolloProvider = ({ children, ...connection }) => {
  const client = useBlocksClient(connection)
  return <ApolloProvider client={client}>{children}</ApolloProvider>
}

export default BlocksApolloProvider
